import * as React from 'react';
import { useSelector } from 'react-redux';
import { IReduxState } from 'src/reduxTypes';
import { UserTypes } from 'src/modules/Auth/store/types';
import { modules } from '../routesModule';
import { IRouteModule } from '../types';


type RouteModuleContextType = [IRouteModule[], UserTypes, React.Dispatch<React.SetStateAction<IRouteModule[]>>]
const RouteModuleContext = React.createContext([] as any as RouteModuleContextType);

const RouteModuleProvider = ({ children }) => {
  const userType = useSelector((reduxState: IReduxState) => reduxState.auth.userType);
  const getModules = (type: UserTypes) => modules(type)
  const [routeModules, setRouteModules] = React.useState<IRouteModule[]>(getModules(userType));
  React.useEffect(() => {
    setRouteModules(getModules(userType));
  }, [userType]);
  return (
    <RouteModuleContext.Provider value={[routeModules, userType, setRouteModules]}>
      {children}
    </RouteModuleContext.Provider>
  )
}

export {
  RouteModuleContext,
  RouteModuleProvider,
};